module.exports = __webpack_public_path__ + "static/img/lifestyle_20.05a3a26d.jpg";